import { defer, LoaderFunction } from 'react-router-dom'

import Collection from '@models/Collection'
import CollectionItem from '@models/CollectionItem'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type BasicCollection = Omit<Collection<unknown>, 'items' | 'document_count' | 'type'>

export type CollectionResponse = {
  collection: BasicCollection
}

export type CollectionItemsResponse = {
  collection_items: CollectionItem[]
  remaining: boolean
  startIndex: number
}

export type CollectionLoaderResponse = {
  collection: Promise<CollectionResponse>
  items: Promise<CollectionItemsResponse>
}

export const COLLECTION_ITEM_PAGE_SIZE = 15

const collectionLoader: LoaderFunction = async ({ params }) => {
  const { collectionId } = params

  const collection = http.loader.post<CollectionResponse>(ApiRoutes.collections.infoPath(), {
    collection_id: collectionId,
    info_only: true,
  })

  const items = http.loader.post<CollectionItemsResponse>(ApiRoutes.collections.itemsPath(), {
    collection_id: collectionId,
    max_count: COLLECTION_ITEM_PAGE_SIZE,
  })

  return defer({ collection, items })
}

export default collectionLoader
